<template>
  <section class="restaurants">
    <TransitionRouterView></TransitionRouterView>
  </section>
</template>

<script>
import TransitionRouterView from '@/containers/TransitionRouterView'

export default {
  components: { TransitionRouterView }
}
</script>

<style lang="scss">
</style>
